import angular from 'angular';

(function () {
    'use strict';
    angular.module('app.core').factory('Brand', Brand);

    Brand.$inject = ['BrandNavigation'];

    /* @ngInject */
    function Brand(BrandNavigation) {
        Brand.prototype = {
            build: build,
            buildEmpty: buildEmpty,
        };

        function Brand(brandData) {
            if (!brandData) {
                this.buildEmpty();
            } else {
                this.build(brandData);
            }
        }

        return Brand;

        /////////////////////

        function buildEmpty() {
            this.id = null;
            this.principalId = null;
            this.communityEid = null;
            this.loginPersonalise = false;
            this.loginUrl = null;
            this.portalPersonalise = false;
            this.brandNavigation = new BrandNavigation();
            this.mailPersonalise = false;
            this.mail = null;
            this.portalName = null;
            this.customerName = null;
            this.customerUrl = null;
            this.contactUrl = null;
            this.registrationReqCode = null;
            this.registrationReq = false;

            this.newBrandResources = [];
        }

        function build(principalBrandData) {
            this.id = principalBrandData.id || null;
            this.principalId = principalBrandData.principalId || null;
            this.communityEid = principalBrandData.communityEid || null;
            this.loginPersonalise = principalBrandData.loginPersonalise;
            this.loginUrl = principalBrandData.loginUrl || null;
            this.portalPersonalise = principalBrandData.portalPersonalise;
            this.brandNavigation = new BrandNavigation(principalBrandData.brandNavigation);
            this.mailPersonalise = principalBrandData.mailPersonalise;
            this.mail = principalBrandData.mail || null;
            this.portalName = principalBrandData.portalName || null;
            this.newBrandResources = principalBrandData.newBrandResources || [];
            this.customerName = principalBrandData.customerName || null;
            this.customerUrl = principalBrandData.customerUrl || null;
            this.contactUrl = principalBrandData.contactUrl || null;
            this.registrationReqCode = principalBrandData.registrationReqCode || null;
            this.registrationReq = principalBrandData.registrationReq;
        }
    }
})();
